import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { Delete } from "@mui/icons-material";

const DeleteTemplateConfirmDialog = ({
  open,
  isDarkMode,
  isDeleting,
  agentName,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      scroll="paper"
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(24, 24, 27, 0.4)",
            backdropFilter: "blur(2px)",
          },
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: "16px",
          border: "1px solid",
          borderColor: isDarkMode ? "rgba(255, 255, 255, 0.12)" : "rgba(228, 228, 231, 1)",
          boxShadow: isDarkMode
            ? "0 25px 50px -12px rgb(0 0 0 / 0.6)"
            : "0 25px 50px -12px rgb(0 0 0 / 0.25)",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontFamily: '"Poppins", sans-serif',
          fontWeight: 600,
          borderBottom: "1px solid",
          borderColor: "divider",
          backgroundColor: isDarkMode
            ? "rgba(255,255,255,0.02)"
            : "rgba(0,0,0,0.02)",
        }}
      >
        Unpublish Template
      </DialogTitle>

      <DialogContent sx={{ pt: 3 }}>
        <Box sx={{ textAlign: "center", py: 2 }}>
          <Typography
            variant="h6"
            sx={{
              fontFamily: '"Poppins", sans-serif',
              fontWeight: 600,
              mb: 1.5,
              color: isDarkMode ? "#ffffff" : "#111827",
            }}
          >
            Are you sure you want to unpublish this template?
          </Typography>

          <Typography
            variant="body2"
            sx={{
              fontFamily: '"Poppins", sans-serif',
              color: isDarkMode ? "#9ca3af" : "#4b5563",
              maxWidth: 520,
              mx: "auto",
              lineHeight: 1.7,
            }}
          >
            This will remove the template version of your agent. The agent itself will remain
            unchanged, but it will no longer be available as a template for others to use.
            {agentName ? `\n\nAgent: ${agentName}` : ""}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          justifyContent: "center",
          gap: 1.5,
        }}
      >
        <Button
          onClick={onClose}
          disabled={isDeleting}
          sx={{
            fontFamily: '"Poppins", sans-serif',
            fontWeight: 600,
            minWidth: 120,
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={isDeleting}
          startIcon={
            isDeleting ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <Delete />
            )
          }
          sx={{
            fontFamily: '"Poppins", sans-serif',
            fontWeight: 700,
            minWidth: 180,
            backgroundColor: "#e36250",
            color: "#ffffff",
            "&:hover": {
              backgroundColor: "#d14e3c",
            },
            "&.Mui-disabled": {
              backgroundColor: "rgba(227, 98, 80, 0.5)",
              color: "rgba(255, 255, 255, 0.7)",
            },
          }}
        >
          {isDeleting ? "Unpublishing..." : "Yes, unpublish template"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteTemplateConfirmDialog;

